// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LCt5snrqc3JTYO {
  background-color: var(--ds-surface-raised, #ffffff);
  border-radius: 8px;
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
  cursor: pointer;
  min-height: 20px;
  position: relative;
  scroll-margin: 8px;
}
.LCt5snrqc3JTYO:focus-within {
  outline: -webkit-focus-ring-color auto 5px;
  outline-style: solid;
  outline-width: 2px;
}
@-moz-document url-prefix() {
  .LCt5snrqc3JTYO:focus-within {
    outline: black dotted 1px;
  }
}
.Y_mLqvFmzyAxzi {
  display: flow-root;
  position: relative;
  padding: 8px 8px 4px 12px;
  z-index: 10;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardFront": `LCt5snrqc3JTYO`,
	"details": `Y_mLqvFmzyAxzi`
};
export default ___CSS_LOADER_EXPORT___;
